// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3pMIa","disabled":"FileBtn_disabled__2Brwx","warn":"FileBtn_warn__CLVRY","fade":"FileBtn_fade__83aXY"};